import "../../css/SignIn/SignIn.css";
import logo from "../../assets/images/logo/logo-with-title.svg";
import MicrosoftIcon from "../../assets/images/microsoft.png";
import SignInButton from "../DesignSystem/Buttons/SignInButton";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useUserEmail } from "./UserEmailContext";
import { useUserPermissions } from "./UserPermissionsContext";

import {
  auth,
  signInWithPopup,
  dbProduction,
} from "../../backend/firebaseConfig";
import {
  OAuthProvider,
  setPersistence,
  browserLocalPersistence,
  signOut,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

// keep auth persisted
setPersistence(auth, browserLocalPersistence).catch(() => {});

const HARDCODED_STAFF_DOC_IDS = {
  "peter.bott@rosemountpartners.co.uk": "peter.bott@rosemountpartners.co.uk",
  "rahool.mukherjee@rosemountpartners.co.uk": "rahool.mukherjee@rosemountpartners.co.uk",
};

const getEmailFromUser = (user) => {
  if (user?.email) return user.email;

  for (const provider of user?.providerData || []) {
    if (provider?.email) return provider.email;
  }

  return null;
};

const normaliseEmail = (email) =>
  String(email || "")
    .toLowerCase()
    .trim();

const SignIn = () => {
  const navigate = useNavigate();
  const { setUserEmail } = useUserEmail("userEmail");
  const { setUserPermissions } = useUserPermissions("userPermissions");

  const handleMicrosoftSignIn = async () => {
    const microsoftProvider = new OAuthProvider("microsoft.com");
    microsoftProvider.setCustomParameters({ prompt: "select_account" });

    try {
      const result = await signInWithPopup(auth, microsoftProvider);
      const user = result.user;

      const email = normaliseEmail(getEmailFromUser(user));

      if (!email) {
        await signOut(auth);
        alert("Error: Unable to retrieve email from Microsoft authentication.");
        return;
      }

      const staffDocId = HARDCODED_STAFF_DOC_IDS[email] || email;

      const userRef = doc(
        dbProduction,
        "Authorized Members",
        "Staff",
        "Data",
        staffDocId,
      );

      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        await signOut(auth);
        alert("Your email is not authorized to sign in.");
        return;
      }

      const userData = userSnap.data() || {};

      const permissions = Array.isArray(userData.permissions)
        ? userData.permissions
        : [];

      setUserEmail(email);
      localStorage.setItem("userEmail", email);

      localStorage.setItem("staffDocId", staffDocId);

      setUserPermissions(permissions);
      localStorage.setItem("userPermissions", JSON.stringify(permissions));

      navigate("/Department/AllStaff");
    } catch (error) {
      console.error("[SignIn] Microsoft sign-in failed:", error);
      alert("Sign-in failed. Please try again.");
    }
  };

  return (
    <div className="SignIn-Container">
      <Helmet>
        <title>Staff Portal - Rosemount Financial Solutions (IFA) Ltd</title>
        <meta
          name="description"
          content="Sign in to the Rosemount Financial Solutions (IFA) Ltd Staff Portal"
        />
      </Helmet>

      <img src={logo} alt="Company Logo" className="logo" />

      <SignInButton
        imgSrc={MicrosoftIcon}
        title="Sign in with Microsoft"
        onClick={handleMicrosoftSignIn}
      />
    </div>
  );
};

export default SignIn;
